import { render, staticRenderFns } from "./SaleHistoryEventSentInfo.vue?vue&type=template&id=1976862f&scoped=true"
import script from "./SaleHistoryEventSentInfo.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventSentInfo.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEventSentInfo.vue?vue&type=style&index=0&id=1976862f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976862f",
  null
  
)

export default component.exports